import Env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';
import {GET_ALL_CLIENTS} from '../actiontypes';

export function getAllClients(excludeDelegated = false) {
	const url = `${Env.getBaseURL(serviceURL)}Clients?excludeDelegated=${excludeDelegated}`;
	return {
		type: GET_ALL_CLIENTS,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		}
	};
}
